import * as React from "react";
import { useState, useEffect } from "react";
import { atom, useSetRecoilState, useRecoilValue } from "recoil";
import $ from "jquery";
import { useFirebaseUser } from "./firebase-auth";
// import UnopenedPackCounter from "./component/UnopenedPackCounter";
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//import { faCheckSquare } from '@fortawesome/free-solid-svg-icons'
//import { faSquare } from '@fortawesome/free-regular-svg-icons'

export const $register = atom({
  key: "CHECKSTEPS::REGISTER", // Atoms needs a unique key, we can only ever call the atom function once with this key.
  default: false,
});

export const $wallet = atom({
  key: "CHECKSTEPS::WALLET", // Atoms needs a unique key, we can only ever call the atom function once with this key.
  default: false,
});

export const $game = atom({
  key: "CHECKSTEPS::GAME", // Atoms needs a unique key, we can only ever call the atom function once with this key.
  default: false,
});

// Our actual hook
export function useCheckSteps() {
  const didRegister = useRecoilValue($register);
  const didWallet = useRecoilValue($wallet);
  const didGame = useRecoilValue($game);

  return {
    didRegister: didRegister,
    didWallet: didWallet,
    didGame: didGame,
  };
}

export function CheckSteps() {
  //console.log("TOKEN: " + accessToken);
  const firebaseUser = useFirebaseUser();
  const [hasGame, setHasGame] = useState(false);
  const [gameNames, setGameNames] = useState("");
  const [didCheck, setDidCheck] = useState(false);

  const setRegister = useSetRecoilState($register);
  const setWallet = useSetRecoilState($wallet);
  const setGame = useSetRecoilState($game);

  useEffect(() => {
    // Confirm the link is a sign-in with email link.
    if (firebaseUser.didAuth && !didCheck) {
      setDidCheck(true);

      $.ajax(
        "https://0eg36enfd5.execute-api.us-west-2.amazonaws.com/prod/getRegisteredAccounts",
        {
          method: "GET",
          beforeSend: function (xhr) {
            xhr.setRequestHeader(
              "Authorization",
              "Bearer " + firebaseUser.accessToken
            );
          },
          /*data: {
			externalAccountId: 'totallyrealfirebaseid'
		}*/
        }
      )
        .done(function (oData) {
          if (oData) {
            if (oData.length > 0) {
              setHasGame(true);
              let names = [];
              names.push(
                oData.map((item) => {
                  if (item.gameName == "tpbgame") {
                    return "Trailer Park Boys: Greasy Money";
                  } else if (item.gameName == "bfcc") {
                    return "Cheech and Chong Bud Farm";
                  } else if (item.gameName == "bfweedrev") {
                    return "Bud Farm: Idle Tycoon";
                  }
                })
              );
              setGameNames(names.join(", "));
            } else {
              setHasGame(false);
              setGameNames("");
            }
          }
        })
        .fail(function (jqXHR, textStatus) {
          console.log("CheckSteps failed: " + textStatus);
        });
    }
  }, [firebaseUser.didAuth, firebaseUser.accessToken, didCheck]);

  if (firebaseUser.didAuth && !firebaseUser.hasWallet && !hasGame) {
    setRegister(true);
    setWallet(false);
    setGame(false);
    return (
      <div class="top">
        <ul class="topnav">
          <a href="#about2">Please add a wallet and connect a game!</a>
        </ul>
        <ul class="topnav">
          <img class="number" src="img/check.png" />
          <label class="checkcontainer">
            {" "}
            Register
            <span class="checkmark"></span>
          </label>

          <img class="number" src="img/2.png" />
          <label class="checkcontainer">
            {" "}
            Add Wallet
            <span class="checkmark"></span>
          </label>

          <img class="number" src="img/3.png" />
          <label class="checkcontainer">
            {" "}
            Connect Game
            <span class="checkmark"></span>
          </label>
        </ul>
      </div>
    );
  } else if (firebaseUser.didAuth && firebaseUser.hasWallet && !hasGame) {
    setRegister(true);
    setWallet(true);
    setGame(false);
    return (
      <div class="top">
        <ul class="topnav">
          <a href="#about2">Please choose a game to connect!</a>
        </ul>
        <ul class="topnav">
          <img class="number" src="img/check.png" />
          <label class="checkcontainer">
            {" "}
            Register
            <span class="checkmark"></span>
          </label>

          <img class="number" src="img/check.png" />
          <label class="checkcontainer">
            {" "}
            Add Wallet
            <span class="checkmark"></span>
          </label>

          <img class="number" src="img/3.png" />
          <label class="checkcontainer">
            {" "}
            Connect Game
            <span class="checkmark"></span>
          </label>
          <p class="added">&nbsp;</p>
        {/* <UnopenedPackCounter></UnopenedPackCounter> */}
        </ul>

      </div>
    );
  } else if (firebaseUser.didAuth && firebaseUser.hasWallet && hasGame) {
    setRegister(true);
    setWallet(true);
    setGame(true);
    return (
      <div class="top">
        <ul class="topnav">All steps complete! You're fully registered!</ul>
        <ul class="topnav">
          <img class="number" src="img/check.png" />
          <label class="checkcontainer">
            {" "}
            Register
            <span class="checkmark"></span>
          </label>

          <img class="number" src="img/check.png" />
          <label class="checkcontainer">
            {" "}
            Add Wallet
            <span class="checkmark"></span>
          </label>

          <img class="number" src="img/check.png" />
          <label class="checkcontainer">
            {" "}
            Connect Game
            <span class="checkmark"></span>
          </label>
          <p class="added">You connected: {gameNames}</p>
        </ul>
        {/* <UnopenedPackCounter></UnopenedPackCounter> */}

      </div>
    );
  } else if (firebaseUser.didAuth && !firebaseUser.hasWallet && hasGame) {
    setRegister(true);
    setWallet(false);
    setGame(true);
    return (
      <div class="top">
        <ul class="topnav">
          <a href="#about2">Please add a wallet!</a>
        </ul>
        <ul class="topnav">
          <img class="number" src="img/check.png" />
          <label class="checkcontainer">
            {" "}
            Register
            <span class="checkmark"></span>
          </label>

          <img class="number" src="img/2.png" />
          <label class="checkcontainer">
            {" "}
            Add Wallet
            <span class="checkmark"></span>
          </label>

          <img class="number" src="img/check.png" />
          <label class="checkcontainer">
            {" "}
            Connect Game
            <span class="checkmark"></span>
          </label>
          <p class="added">You connected: {gameNames}</p>
        </ul>
      </div>
    );
  } else {
    setRegister(false);
    setWallet(false);
    setGame(false);
    return (
      <div class="top">
        <ul class="topnav">
          <a href="#about2">
            Please complete the steps below to fully register!
          </a>
        </ul>
        <ul class="topnav">
          <img class="number" src="img/1.png" />
          <label class="checkcontainer">
            {" "}
            Register
            <span class="checkmark"></span>
          </label>

          <img class="number" src="img/2.png" />
          <label class="checkcontainer">
            {" "}
            Add Wallet
            <span class="checkmark"></span>
          </label>

          <img class="number" src="img/3.png" />
          <label class="checkcontainer">
            {" "}
            Connect Game
            <span class="checkmark"></span>
          </label>
          <p class="added">&nbsp;</p>
        </ul>
      </div>
    );
  }
}
